module.exports = __webpack_public_path__ + "static/media/clear.0e92e335.svg";